// extracted by mini-css-extract-plugin
module.exports = {"root":"_2XuPu","bottomTextWrapper":"_1a2yT","section":"QaGg-","carouselContainer":"_1kdjn"};